import { createUseStyles } from "react-jss";
import { getSpacing } from "../../../theme/Mixins";

export default createUseStyles({
    drillDown: {
        composes: "drill-down",
        marginTop: ({ theme }) => getSpacing(theme, 0, theme.QuestionSpacing?.WithinComponents),
    },
    variable: {
        composes: "drill-down__variable",
    },
    label: {
        composes: "drill-down__label",
        display: "block",
        fontWeight: 600,
        marginTop: ({ theme }) => getSpacing(theme, 20, theme.QuestionSpacing?.WithinComponents),
        marginBottom: 4,
    },
});
